export default "__VITE_ASSET__BZ8bocFv__"